import { render, staticRenderFns } from "./SafetyConfirmOtherUserQuestions.vue?vue&type=template&id=0f4ee58b&lang=pug"
import script from "./SafetyConfirmOtherUserQuestions.vue?vue&type=script&lang=ts"
export * from "./SafetyConfirmOtherUserQuestions.vue?vue&type=script&lang=ts"
import style0 from "./SafetyConfirmOtherUserQuestions.vue?vue&type=style&index=0&id=0f4ee58b&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports